import VideoJsAdapter from '@javascripts/adapters/videojs_adapter';
import FullscreenApiAdapter from '@javascripts/adapters/fullscreen_api_adapter';
import LocationAdapter from '@javascripts/adapters/location_adapter';
import VideoHelpers from "@javascripts/utils/video_helpers";

export default class ButtonLogin {
  constructor({ data, tech } = {}) {
    this._tech = tech;
    this._data = data;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  contentGatingDuration(){
    if(this.data()){
      return this.data().contentGatingDuration();
    }

    return undefined;
  }

  hasContentGatingDuration() {
    return this.contentGatingDuration() != undefined && this.contentGatingDuration() !== -1;
  }

  init() {
    if(this.hasContentGatingDuration()) this._remainingContentGatingDuration = this.contentGatingDuration();

    this.appendLoginButtonOnStart();
  }

  destroy(){
    this.tech().el().removeChild(this._button)
  }

  appendLoginButtonOnStart() {
    this.tech().one('playing', () => {
      this.tech().el().appendChild(this.createButton());

      if(this.hasContentGatingDuration()){
        this.bindPlayerInteractionHandler();
      }else{
        this.bindTimeUpdate();
      }
    });
  }

  createButton() {
    this._button = document.createElement('button');
    this._button.className = 'login-button';
    this._button.innerHTML = this.getButtonText();
    this._button.onclick = () => {
      FullscreenApiAdapter.exitFullscreen();
      this.tech().pause();
      LocationAdapter.href(this.data().contentGatingUrl())
    };

    return this._button;
  }

  getButtonText() {
    const remainingTime = this.hasContentGatingDuration() ? this.remainingContentGatingDuration() : this.remainingTime();
    const formattedTime = VideoJsAdapter.formatTime(remainingTime);

    return `<b>${window.Locale[VideoHelpers.getLang()].content_gating_banner.login.cta_button}</b>&nbsp;&nbsp;&nbsp; ${formattedTime}`;
  }

  remainingTime() {
    return Math.ceil(this.tech().remainingTime());
  }

  bindTimeUpdate() {
    this.tech().on('timeupdate', () => {
      this._button.innerHTML = this.getButtonText();
    });
  }

  bindPlayerInteractionHandler(){
    let isPaused= false
    this._playedTime = 0

    const gatingDurationInterval = setInterval(() => {
      if(!isPaused){
        this._playedTime += .1
        this._button.innerHTML = this.getButtonText();

        if(this.remainingContentGatingDuration() <= 0) clearInterval(gatingDurationInterval)
      }
    }, 100);

    this.tech().on('pause', () => {
      isPaused = true
    });

    this.tech().on('play', () => {
      isPaused = false
    });
  }

  remainingContentGatingDuration() {
    if(this.data().isLivestreaming()){
      return this.contentGatingDuration() - this._playedTime
    }else{
      return this.contentGatingDuration() - this.tech().currentTime()
    }
  }
}
